/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ScheduleTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type ReportScheduleType = ScheduleTypeRepresentation;
export const ReportScheduleType = ScheduleTypeRepresentation;
